(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-disco-modal-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  const COOKIE_KEY_PREFIX = 'disco_modal_seen_';

  function setCookie(name, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=1; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
  }

  function hasCookie(name) {
    return document.cookie.split(';').some(function (c) {
      return c.trim().startsWith(name + '=');
    });
  }

  function openModal(modal, backdrop) {
    modal.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal, backdrop, cookieKey, cookieDays, showOnce) {
    modal.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (showOnce) {
      setCookie(cookieKey, cookieDays);
    }
  }

  function initModal(modal) {
    var sectionId  = modal.dataset.sectionId;
    var delay      = parseInt(modal.dataset.delay, 10) || 0;
    var showOnce   = modal.dataset.showOnce === 'true';
    var cookieDays = parseInt(modal.dataset.cookieDays, 10) || 7;
    var cookieKey  = COOKIE_KEY_PREFIX + sectionId;
    var backdropId = modal.id + '-backdrop';
    var backdrop   = document.getElementById(backdropId);

    if (!backdrop) return;

    /* If the modal is CSS-hidden (e.g. hide_on_mobile on a small screen), skip entirely */
    if (getComputedStyle(modal).display === 'none') return;

    if (showOnce && hasCookie(cookieKey)) return;

    function doOpen() {
      openModal(modal, backdrop);
    }

    if (delay > 0) {
      setTimeout(doOpen, delay * 1000);
    } else {
      doOpen();
    }

    /* Close via X button */
    modal.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(modal, backdrop, cookieKey, cookieDays, showOnce);
      });
    });

    /* Close via backdrop click */
    backdrop.addEventListener('click', function () {
      closeModal(modal, backdrop, cookieKey, cookieDays, showOnce);
    });

    /* Close when clicking outside the inner card */
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal(modal, backdrop, cookieKey, cookieDays, showOnce);
      }
    });

    /* Close via Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal(modal, backdrop, cookieKey, cookieDays, showOnce);
      }
    });
  }

  document.querySelectorAll('.disco-modal[data-section-id]').forEach(initModal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-order-request"] && !Shopify.designMode) return;
  try {
    
  /* The form app renders its submit button asynchronously, so the notice is moved in above it once it exists */
  class CustomRequestForm extends HTMLElement {
    connectedCallback() {
      this.notice = this.querySelector('.custom-request__notice');
      if (!this.notice) return;

      this.observer = new MutationObserver(() => this.placeNotice());
      this.observer.observe(this, { childList: true, subtree: true });
      this.placeNotice();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    placeNotice() {
      const submit = this.querySelector('.custom-request__app .gfb__footer .wizard__submit');
      if (!submit || submit.previousElementSibling === this.notice) return;

      submit.before(this.notice);
    }
  }

  if (!customElements.get('custom-request-form')) {
    customElements.define('custom-request-form', CustomRequestForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
